import {jsPDF} from "jspdf";
import { autoTable } from 'jspdf-autotable'
import * as XLSX from "xlsx";

export const exportHistoryData = (data, selectedFields, type) => {
  const headers = Object.entries(selectedFields)
    .filter(([_, selected]) => selected)
    ?.map(([field]) => field);

  const exportData = data?.map((row) =>
    headers?.map((field) => row[field] ?? "")
  );

  if (type === "PDF") {
    const doc = new jsPDF();
    autoTable(doc, {
      head: [headers],
      body: exportData,
    });
    doc.save("history_report.pdf");
  } else {
    const ws = XLSX.utils.aoa_to_sheet([headers, ...exportData]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, "history_report.xlsx");
  }
};
